import React, {
  useContext,
} from 'react';
import { IntlProvider } from 'react-intl';
import translationLabels from '@/lang/en';
import { LocaleContext } from '@/providers/LocaleProvider';

export default function TranslationProvider(
  { children }: React.PropsWithChildren,
): React.ReactElement {
  const localeContext = useContext(LocaleContext);

  return (
    <IntlProvider locale={localeContext.locale} messages={translationLabels}>
      {children}
    </IntlProvider>
  );
}
